import { Injectable } from '@angular/core';
import { TestSubTypeConstants } from '../../shared-all/constants/test.constants';

@Injectable()
export class TestHelperService {

    constructor() { }

    updateTestTypeTagsInItem(selectedItemData) {
        if (!selectedItemData) {
            return;
        }
        if (selectedItemData.model && selectedItemData.model['test-type']) {
            selectedItemData.testTagType = selectedItemData.model['test-type'];
        }
    }


      getTestTypeTagFromItem(selectedItemData) {
          if (!selectedItemData.testTagType){
              this.updateTestTypeTagsInItem(selectedItemData);
          }
          return selectedItemData.testTagType;
      }
    
    isValidTestType(selectedItemTestType) {
        return Object.keys(TestSubTypeConstants).some(key => TestSubTypeConstants[key] === selectedItemTestType);
    }

}